import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "page seven-wonders-architect-page" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("7 Wonders Architect")
const _hoisted_3 = {
  key: 0,
  class: "player-form-container"
}
const _hoisted_4 = { class: "player-counter-infos-container" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "number-player-select",
  style: {"display":"block"}
}, "Nombre de joueurs ", -1)
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = { for: "username" }
const _hoisted_8 = {
  key: 1,
  class: "sort-game-infos"
}
const _hoisted_9 = { class: "action-buttons-form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Fieldset = _resolveComponent("Fieldset")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Fieldset, null, {
      legend: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        (!_ctx.isAvailableResult)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_InputNumber, {
                  id: "number-player-select",
                  modelValue: _ctx.numberOfPlayer,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.numberOfPlayer) = $event)),
                  showButtons: "",
                  buttonLayout: "horizontal",
                  incrementButtonIcon: "pi pi-plus",
                  decrementButtonIcon: "pi pi-minus",
                  step: 1,
                  min: 2,
                  max: 7
                }, null, 8, ["modelValue"])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numberOfPlayer, (m) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: m,
                  class: "player-name-input"
                }, [
                  _createElementVNode("span", _hoisted_6, [
                    _createVNode(_component_InputText, {
                      id: "username",
                      type: "text",
                      modelValue: _ctx.playerNames[m - 1],
                      "onUpdate:modelValue": ($event: any) => ((_ctx.playerNames[m - 1]) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _createElementVNode("label", _hoisted_7, _toDisplayString(`Joueur ${m}`), 1)
                  ])
                ]))
              }), 128)),
              _createVNode(_component_Button, {
                disabled: !_ctx.isValidForm,
                onClick: _ctx.affectWonders,
                label: "Définir les merveilles"
              }, null, 8, ["disabled", "onClick"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.affectedWonders, (result) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `${result.playerName}_${result.wonder}`
                }, [
                  _createTextVNode(_toDisplayString(result.playerName) + " va jouer avec ", 1),
                  _createElementVNode("b", null, _toDisplayString(result.wonder), 1)
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Button, {
                  onClick: _ctx.resetAffectedWonders,
                  class: "p-button-link",
                  label: "Modifier"
                }, null, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  onClick: _ctx.affectWonders,
                  label: "Recommencer"
                }, null, 8, ["onClick"])
              ])
            ]))
      ]),
      _: 1
    })
  ]))
}